export default "__VITE_ASSET__BC9u304A__"